import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Inbox, Mail, FileText, TrendingUp } from "lucide-react";

function Stat({ icon: Icon, label, value }) {
  return (
    <div className="bg-brand-offwhite border border-brand-gold-light/40 rounded-sm p-6">
      <Icon className="text-brand-gold" size={24} />
      <div className="font-serif text-4xl text-brand-green mt-3">{value}</div>
      <div className="text-brand-text/60 text-sm mt-1">{label}</div>
    </div>
  );
}

export default function Dashboard() {
  const [d, setD] = useState(null);

  useEffect(() => { api.get("/admin/dashboard").then(({ data }) => setD(data)).catch(() => {}); }, []);

  if (!d) return <p className="text-brand-text/50">Yükleniyor…</p>;

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-serif text-4xl text-brand-green mb-8">Dashboard</h1>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 mb-10">
        <Stat icon={Inbox} label="Toplam Lead" value={d.total_leads} />
        <Stat icon={TrendingUp} label="Son 30 Gün Lead" value={d.recent_leads} />
        <Stat icon={Mail} label="Mektup Aboneleri" value={d.newsletter} />
        <Stat icon={FileText} label="Yayında İçerik" value={d.published} />
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <div className="bg-brand-offwhite border border-brand-gold-light/40 rounded-sm p-7">
          <h3 className="font-serif text-2xl text-brand-green mb-5">En çok ilgi gören programlar</h3>
          {d.top_programs.length === 0 && <p className="text-brand-text/50 text-sm">Henüz veri yok.</p>}
          <ul className="space-y-3">
            {d.top_programs.map((t, i) => (
              <li key={i} className="flex justify-between items-center border-b border-brand-gold-light/30 pb-2">
                <span className="text-brand-text/80 text-sm">{t.program}</span>
                <span className="font-semibold text-brand-green">{t.count}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="bg-brand-offwhite border border-brand-gold-light/40 rounded-sm p-7">
          <h3 className="font-serif text-2xl text-brand-green mb-5">Lead durumları</h3>
          <ul className="space-y-3">
            {Object.entries(d.leads_by_status).map(([k, v]) => (
              <li key={k} className="flex justify-between items-center border-b border-brand-gold-light/30 pb-2">
                <span className="text-brand-text/80 text-sm">{k}</span>
                <span className="font-semibold text-brand-green">{v}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="bg-brand-offwhite border border-brand-gold-light/40 rounded-sm p-7 lg:col-span-2">
          <h3 className="font-serif text-2xl text-brand-green mb-5">Son içerikler</h3>
          <ul className="space-y-2">
            {d.latest_content.map((c, i) => (
              <li key={i} className="flex justify-between items-center text-sm border-b border-brand-gold-light/30 pb-2">
                <span className="text-brand-text/80">{c.title}</span>
                <span className={`text-xs px-2 py-0.5 rounded-full ${c.status === "published" ? "bg-brand-green text-brand-offwhite" : "bg-brand-gold-light text-brand-green"}`}>{c.status}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
